import * as React from 'react';

import * as styles from './styles.css';

export const CommunicationPaymentIllustration: React.FC = () => {
  return <div className={styles['payment']} />;
};
